import { render, staticRenderFns } from "./MediaDownloadPDFItem.vue?vue&type=template&id=00ca32bb&scoped=true&"
import script from "./MediaDownloadPDFItem.vue?vue&type=script&lang=ts&"
export * from "./MediaDownloadPDFItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaDownloadPDFItem.vue?vue&type=style&index=0&id=00ca32bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca32bb",
  null
  
)

export default component.exports